import type { StaticImageData } from "next/image";
import { Star, Store, Users } from "lucide-react";

export type TestimonialGender = "male" | "female";

export type TestimonialItem = {
  id: string;
  name: string;
  content: string;
  rating: number;
  gender?: TestimonialGender;
  avatar?: StaticImageData | string;
  feature?: StaticImageData | string;
  reference?: StaticImageData | string;
  authorType?: TestimonialAuthorType;
  position?: string | null;
  createdDt?: string;
};

/** ******************************
 * API types (GET /v2/core/testimonials)
 ****************************** */
export type TestimonialAuthorType = "merchant" | "customer";
export type TestimonialSortBy = "id" | "createdDt" | "rating" | "position";
export type TestimonialSortOrder = "asc" | "desc";

export type TestimonialQuery = {
  authorType?: TestimonialAuthorType | null;
  page?: number;
  limit?: number;
  sortBy?: TestimonialSortBy | null;
  sortOrder?: TestimonialSortOrder | null;
};

export type TestimonialRes = {
  id: number;
  authorId: number | null;
  authorType: TestimonialAuthorType;
  authorName: string;
  position: string | null;
  rating: number;
  content: string;
  feature: string | null;
  referenceImage: string | null;
  avatar: string | null;
  createdDt: string;
};

/** Map an API testimonial to the shape used by TestimonialCard. */
export const toTestimonialItem = (res: TestimonialRes): TestimonialItem => ({
  id: String(res.id),
  name: res.authorName,
  content: res.content,
  rating: res.rating,
  avatar: res.avatar ?? undefined,
  feature: res.feature ?? undefined,
  reference: res.referenceImage ?? undefined,
  authorType: res.authorType,
  position: res.position,
  createdDt: res.createdDt,
});

export type TestimonialStat = {
  id: "rating" | "travelers" | "merchants";
  value: string;
  label: string;
};

export const TESTIMONIAL_STATS: TestimonialStat[] = [
  { id: "rating", value: "4.9", label: "App Rating" },
  { id: "travelers", value: "100K+", label: "Happy travelers" },
  { id: "merchants", value: "600+", label: "Local merchants" },
];

export const STAT_ICON: Record<TestimonialStat["id"], typeof Star> = {
  rating: Star,
  travelers: Users,
  merchants: Store,
};
